const _version = "2.12.2"
function version() {
    return _version
}
export default version
